import { Chip, type ChipSize } from "./chip";

export interface ActionNeededBadgeProps {
  /** Localised text, e.g. "Action needed". */
  label: string;
  size?: ChipSize;
  className?: string;
}

/**
 * "The ball is in the client's court." Accent (a signal, never an action: CLAUDE.md rule 10) + bell + text.
 * A plain `span`: it has no handler and no button role by design.
 */
export function ActionNeededBadge({ label, size = "md", className }: ActionNeededBadgeProps) {
  return (
    <Chip tone="accent" icon="bell" size={size} className={className} data-action-needed="true">
      {label}
    </Chip>
  );
}
